import { MarketingUpdateRoutes } from 'broker/broker-routes';

export const marketingUpdateSteps = [MarketingUpdateRoutes.Compose, MarketingUpdateRoutes.Upload];

export interface MarketingUpdateLocationState {
  omitEmailStep?: boolean;
}
